import { ColDef } from '@ag-grid-community/core';

export const columnDefs: Array<ColDef> = ([
    {
        field: 'type',
        headerName: 'Type',
        menuTabs: [],
        flex: 1
    },
    {
        field: 'total',
        headerName: 'Total',
        menuTabs: [],
        flex: 1
    },
    {
        field: 'locked',
        headerName: 'Locked',
        menuTabs: [],
        flex: 1
    }
]);